import BookFreeClassBtn from '@components/common/book-free-class-btn'
import NumberedStarCard from '@components/common/numbered-star-card'
import { HOW_CLASS_WORKS } from '@lib/data/course-landing-page'
import { CourseNameType } from '@lib/types/course-landing-page'

const STEP_COLORS = [
  'text-orange',
  'text-blue-200',
  'text-violet-100',
  'text-yellow-200',
]

type Props = {
  courseName: CourseNameType
  urlQuery?: string
}

const HowClassWorks = ({ courseName, urlQuery }: Props) => {
  const data = HOW_CLASS_WORKS[courseName]
  if (!data) return null

  return (
    <div className="my-10 lg:px-3 py-5 flex flex-col text-grey">
      <h2 className="text-2xl font-600 leading-tight mb-4">
        How a Codingal class actually works
      </h2>
      <p className="lg:text-lg mb-5">
        Every Codingal {data.gradeLabel} class is a live, 45 to 60 minute online
        session with a Computer Science teacher. Parents can choose 1:1 or a
        small group (up to 4 students). Every class follows the same four part
        structure.
      </p>
      <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
        {data.steps.map((item, index) => (
          <NumberedStarCard
            key={item.step}
            id={item.step}
            title={`${item.title} (${item.duration})`}
            description={item.description}
            textColor={STEP_COLORS[index % STEP_COLORS.length]}
            className="p-6"
          />
        ))}
      </div>
      <p className="lg:text-lg mt-6 text-grey-800">
        After every class, students receive practice activities, a short quiz
        and their completed project to show parents. Parents receive a monthly
        progress update.
      </p>
      <div className="mx-auto w-full md:max-w-xs mt-8 text-center">
        <BookFreeClassBtn query={urlQuery} />
      </div>
    </div>
  )
}

export default HowClassWorks
